import React from "react";

const LEGEND_ITEMS = [
  { id: "market", label: "Market", color: "#7145D0" },
  { id: "trade", label: "Trade", color: "#79E08F" },
];

const PriceChartLegend = () => {
  return (
    <div className="rc-price-chart-legend" aria-label="Price chart legend">
      {LEGEND_ITEMS.map((item) => (
        <span key={item.id} className="rc-price-chart-legend__item">
          <span
            className="rc-price-chart-legend__dot"
            style={{ backgroundColor: item.color }}
            aria-hidden="true"
          />
          {item.label}
        </span>
      ))}
    </div>
  );
};

export default PriceChartLegend;
